<template>
  <div class="card-recipe-detail">
    <detail-card
      v-for="(recipe, p) in items"
      :key="`${recipe.id}${p}`"
      :medical-record-id="id"
      :recipe="recipe"
      :can-sign="canSign"
      :patient="patient"
      :professional-name="professionalName"
    />
  </div>
</template>

<script>
import DetailCard from './DetailCard.vue';

export default {
  components: {
    DetailCard,
  },
  props: {
    id: {
      type: String,
    },
    items: {
      type: Array,
    },
    canSign: {
      type: Boolean,
      default: false,
    },
    patient: {
      type: Object,
      default: null,
    },
    professionalName: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/_variables.scss";

.card-recipe-detail {
  .recipe-detail-notes {
    white-space: pre-wrap;
  }
}
</style>
